module.exports = __webpack_public_path__ + "img/smile_logo.a1a74556.png";